import React from 'react';
import './App.css';

import { VideoProvider } from './providers/VideoContext';
import VideoScreen from './components/VideoScreen';

const App: React.FC = () => {
  return (
    <div style={{backgroundColor: 'black'}}>
      <VideoProvider>
        <VideoScreen />
      </VideoProvider>
    </div>
  );
}

export default App;
